import { Observable } from 'rxjs';

export enum FilterDisplayType {
  CHECKBOX = 'Checkbox',
  RADIO = 'Radio',
  RADIO_HIERARCHY = 'RadioHierarchy',
  LIST = 'List',
  LIST_HIERARCHY = 'ListHierarchy',
  LOCATION = 'location',
  SLIDE = 'Slide',
}

export enum FilterErrorTypes {
  Location = 'location',
}

export interface FilterSlideData {
  minValue: number;
  maxValue: number;
  priceCurrency?: string;
}

export interface FilterConfigBlock {
  label: string;
  inputId: string;
  type: FilterDisplayType;
  listLabel?: string;
  filterName: string;
  filterValue?: any;
  displayData?: Observable<any>;
  displayDatas?: { [key: string]: Observable<any> };
  selectedLabel?: string;
  icon?: string;
  toolTipLabel?: string;
  isMultiSelect?: boolean;
}

export interface FilterComponentData {
  diningModuleMultiFiltersForCuisine: boolean;
  diningModuleMultiFiltersForCategory: boolean;
  memberEventsModuleMultiFiltersForCategory: boolean;
  entertainmentModuleMultiFiltersForCategory: boolean;
  memberBenefitsModuleMultiFiltersForCategory: boolean;
  articlesModuleMultiFiltersForCategory: boolean;
  travelModuleCarsMultiFiltersForCategory: boolean;
  travelModuleHotelsMultiFiltersForStarRating: boolean;
  preferencesModuleMultiFiltersForCategory: boolean;
  travelModuleActivitiesMultiFiltersForSpecials: boolean;
  travelModuleActivitiesMultiFiltersForTimeOfDay: boolean;
  travelModuleActivitiesMultiFiltersForDuration: boolean;
}

export interface ExtraData {
  minPrice?: number;
  maxPrice?: number;
  priceCurrency?: string;
  hasInstalments?: boolean;
  showDirectReturningFlightFilter?: boolean;
}

export const filterNameMappingForTracking = {
  member_favourite: 'Member Favourite',
  new_offer: 'New Offer',
  expiring_soon: 'Expiring Soon',
  tag: 'Category',
  category: 'Category',
  interest_category: 'Category',
  is_followed: "Events you're following",
  cuisine: 'Cuisine',
  location: 'Location',
  complimentary_tickets: 'Complimentary tickets',
  virtual_events: 'Virtual events',
  property_class: 'star_rating',
  amenity: 'amenity',
  ghc_only: 'ghc_only',
  min_price: 'min_price',
  max_price: 'max_price',
  airline: 'airline',
  departure_time: 'departure_time',
  return_time: 'return_time',
  outbound_direct_flight_only: 'outbound_direct_flight_only',
  inbound_direct_flight_only: 'inbound_direct_flight_only',
  automatic_only: 'automatic_only',
  car_type: 'car_type',
  pax_capacity: 'pax_capacity',
  supplier: 'supplier',
  hotel_instalments_banner: 'hotel_instalments_banner',
};
